import { ApolloLink, Observable } from '@apollo/client';

import { Kind } from 'graphql/language/kinds';

import { OperationDefinitionNode, OperationTypeNode } from 'graphql/language/ast';

import { LoadingAnimationManager } from '../loadingAnimationManager';

export const loadingAnimationManager = new LoadingAnimationManager();

export const loadingAnimationLink = new ApolloLink((operation, forward) => {
  const operationDefinition = operation.query.definitions
    .find((def) => def.kind === Kind.OPERATION_DEFINITION) as OperationDefinitionNode;
  const context = operation.getContext();
  const skipLoadingAnimation = context?.skipLoadingAnimation === true;
  const loadingAnimationNeeded = operationDefinition?.operation === OperationTypeNode.MUTATION && !skipLoadingAnimation;
  if(loadingAnimationNeeded) {
    loadingAnimationManager.showLoading();
  }

  return new Observable((observer) => {
    const subscription = forward(operation).subscribe({
      next: (result) => {
        if(loadingAnimationNeeded) {
          loadingAnimationManager.hideLoading();
        }
        observer.next(result);
      },
      error: (error) => {
        if(loadingAnimationNeeded) {
          loadingAnimationManager.hideLoading();
        }
        observer.error(error);
      },
      complete: () => {
        observer.complete();
      },
    });

    return () => {
      subscription.unsubscribe();
    };
  });
});
